/**
 * Marca padrão da instalação (carga inicial) — Nexora Grid (frontend, US-4502).
 *
 * Criado em: 02/11/2026 · Última modificação: 02/11/2026 · Versão: 1.0.0
 *
 * Só vale até a resposta de `GET /api/v1/marca` (e sem backend). Igual à `MARCA_PADRAO` de `backend/marca.py`.
 * Único arquivo do frontend com o nome da marca escrito (a varredura de `test_marca.py` permite este).
 */
import type { Marca } from "./marca";

export const MARCA_PADRAO: Marca = {
  produto: "Optimale Grid", nome_curto: "Optimale", empresa: "Optimale", razao_social: "", cnpj: "", site: "",
  email_suporte: "", telefone_suporte: "", remetente_email: "Optimale Grid",
  cores: { primaria: "#007DC5", secundaria: "#8BC441", destaque: "#40BEE6" },
  cores_por_modo: {
    escuro: { primaria: "#0DA7FF", secundaria: "#8BC441", destaque: "#40BEE6" },
    claro: { primaria: "#0070B1", secundaria: "#527524", destaque: "#137493" },
    contraste: { primaria: "#08A5FF", secundaria: "#8BC441", destaque: "#40BEE6" },
  },
  arquivos: {
    colorida: { url: "/marca/optimale.svg", tipo: "image/svg+xml" },
    negativa: { url: "/marca/optimale-negativo.svg", tipo: "image/svg+xml" },
    icone: { url: "/marca/icone-512.png", tipo: "image/png" },
  },
  icones: { "32": "/marca/icone-32.png", "192": "/marca/icone-192.png", "512": "/marca/icone-512.png" },
  versao: 0,
};
